import { render, staticRenderFns } from "./PromisePay.vue.js?vue&type=template&id=b481c0aa!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PromisePay.vue?vue&type=template&id=b481c0aa"
import script from "./PromisePay.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PromisePay.vue?vue&type=script&lang=js"
export * from "./PromisePay.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PromisePay.vue?vue&type=script&lang=js"
import style0 from "./PromisePay.vue.less?vue&type=style&index=0&id=b481c0aa&prod&lang=less!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PromisePay.vue?vue&type=style&index=0&id=b481c0aa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports